import React from 'react';

const Note = () => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 8C0 3.58172 3.58172 0 8 0H28C32.4183 0 36 3.58172 36 8V28C36 32.4183 32.4183 36 28 36H8C3.58172 36 0 32.4183 0 28V8Z"
      fill="white"
    />
    <path
      d="M27.75 8.79163H8.25V26.4583C8.25 28.6674 10.0409 30.4583 12.25 30.4583H23.75C25.9591 30.4583 27.75 28.6674 27.75 26.4583V8.79163Z"
      stroke="#3448FF"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M15.832 8.79163V7.70829C15.832 6.51663 16.807 5.54163 17.9987 5.54163C19.1904 5.54163 20.1654 6.51663 20.1654 7.70829V8.79163"
      stroke="#3448FF"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M22.875 8.79163V10.9583C22.875 11.5541 22.3875 12.0416 21.7917 12.0416H14.2083C13.6125 12.0416 13.125 11.5541 13.125 10.9583V8.79163"
      stroke="#3448FF"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
  </svg>
);

export default Note;
